var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"time-input",attrs:{"type":"time","disabled":_vm.disabled},domProps:{"value":_vm.inputValue},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }